<template>
  <header class="header" :class="{ 'home-header': isHomePage }">
    <div class="header-container">
      <div class="header-left">
        <div class="logo-area" @click="$router.push('/')">
          <img src="@/assets/logo.png" alt="Logo" />
        </div>

        <nav class="nav-menu">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="nav-item"
            active-class="active"
          >
            {{ item.label }}
            <span class="underline"></span>
          </router-link>
        </nav>
      </div>

      <div class="user-actions">
        <a-dropdown placement="bottomCenter" v-if="$store.state.user.userInfo.token">
          <div class="user-info-trigger">
            <a-badge
              :dot="totalUnhandledCount > 0"
            >
              <div class="user-avatar">
                <img src="@/assets/login-avatar.png" alt="User Avatar" />
              </div>
            </a-badge>
            <span class="user-name">
              {{
                $store.state.user.userInfo.role === 'SupplierSubAccount' ||
                $store.state.user.userInfo.role === 'PurchaserSubAccount'
                  ? $store.state.user.userInfo.contactName
                  : $store.state.user.userInfo.name
              }}
            </span>
          </div>
          <a-menu slot="overlay" class="user-dropdown-menu">
            <a-menu-item
              key="profile"
              style="margin-bottom: 10px;"
              @click="handleClickCenter"
            >
              个人中心
            </a-menu-item>
            <a-menu-item
              v-if="showWorkCenterEntry"
              key="message-center"
              style="margin-bottom: 10px;"
              @click="handleClickMessageCenter"
            >
              <div class="work-center-menu-item">
                <span>消息中心</span>
                <a-badge
                  v-if="unhandledMessageCount > 0"
                  :count="unhandledMessageCount"
                  :overflow-count="99"
                />
              </div>
            </a-menu-item>
            <a-menu-item
              v-if="showWorkCenterEntry"
              key="todo-center"
              style="margin-bottom: 10px;"
              @click="handleClickTodoCenter"
            >
              <div class="work-center-menu-item">
                <span>待办事项</span>
                <a-badge
                  v-if="unhandledTodoCount > 0"
                  :count="unhandledTodoCount"
                  :overflow-count="99"
                />
              </div>
            </a-menu-item>
            <a-menu-item key="logout" @click="handleLogout">
              退出登录
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import { getUserMessageUnhandledCount } from '@/api/system'

export default {
  name: 'HomeHeader',
  props: {
    isHomePage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navItems: [
        { label: '招标信息', path: '/procurement-info' },
        { label: '增值服务', path: '/services' },
        { label: '政策法规', path: '/policy-regulations' },
        { label: '联系我们', path: '/contact' }
      ],
      loading: false,
      unhandledMessageCount: 0,
      unhandledTodoCount: 0,
      totalUnhandledCount: 0
    }
  },
  computed: {
    showWorkCenterEntry() {
      return ['SuperAdmin', 'ProjectAdmin', 'Finance'].includes(this.$store.getters.role)
    }
  },
  watch: {
    '$route.path'() {
      this.syncMessageBadge()
    },
    '$store.state.user.userInfo.token'() {
      this.syncMessageBadge()
    },
    '$store.getters.role'() {
      this.syncMessageBadge()
    }
  },
  created() {
    this.syncMessageBadge()
  },
  mounted() {
    window.addEventListener('message-unhandled-count-change', this.handleMessageBadgeSync)
  },
  beforeDestroy() {
    window.removeEventListener('message-unhandled-count-change', this.handleMessageBadgeSync)
  },
  methods: {
    handleMessageBadgeSync(event) {
      if (!event || !event.detail || event.detail.refresh) {
        this.syncMessageBadge()
        return
      }
      this.unhandledMessageCount = Number(event.detail.unhandledMessageCount || 0)
      this.unhandledTodoCount = Number(event.detail.unhandledTodoCount || 0)
      this.totalUnhandledCount = Number(event.detail.totalUnhandledCount || 0)
    },
    syncMessageBadge() {
      if (!this.$store.state.user.userInfo.token || !this.showWorkCenterEntry) {
        this.unhandledMessageCount = 0
        this.unhandledTodoCount = 0
        this.totalUnhandledCount = 0
        return
      }

      getUserMessageUnhandledCount()
        .then(res => {
          this.unhandledMessageCount = Number(res && res.unhandledMessageCount || 0)
          this.unhandledTodoCount = Number(res && res.unhandledTodoCount || 0)
          this.totalUnhandledCount = Number(res && res.totalUnhandledCount || 0)
        })
        .catch(() => {
          this.unhandledMessageCount = 0
          this.unhandledTodoCount = 0
          this.totalUnhandledCount = 0
        })
    },
    handleClickCenter() {
      const role = this.$store.getters.role
      if (role === 'SuperAdmin' || role === 'ProjectAdmin') {
        this.$router.push('/admin-center')
      } else if (role === 'Supplier' || role === 'SupplierSubAccount') {
        this.$router.push('/supplier-center')
      } else if (role === 'Expert') {
        this.$router.push('/expert-center')
      } else if (role === 'Tenderer') {
        this.$router.push('/tenderer-center')
      } else if (role === 'RelationQueryAccount') {
        this.$router.push('/admin-center/relation-query')
      } else if (role === 'Purchaser' || role === 'PurchaserSubAccount') {
        this.$router.push('/purchaser-center/personal-info')
      } else if (role === 'Finance') {
        this.$router.push('/finance-center')
      }
    },
    handleClickMessageCenter() {
      this.$router.push('/message-center')
    },
    handleClickTodoCenter() {
      this.$router.push('/todo-center')
    },
    handleLogout() {
      this.$confirm({
        title: '确定退出登录吗？',
        content: '',
        okText: '确定',
        cancelText: '取消',
        type: 'warning',
        centered: true,
        onOk: () => {
          this.loading = true
          try {
            this.$store.dispatch('Logout')
            this.$router.push('/')
          } catch (error) {
            this.$message.error('退出登录失败')
          } finally {
            this.loading = false
          }
        },
        onCancel() {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  min-width: 1200px;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom: 1px solid #dbeafe;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  .header-container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .logo-area {
    cursor: pointer;
    margin-right: 36px;

    img {
      width: 128px;
      height: auto;
    }
  }

  .nav-menu {
    display: flex;

    .nav-item {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #2a375e;
      font-weight: 500;
      font-size: 18px;
      margin-right: 18px;
      position: relative;

      &:hover,
      &.active {
        color: #5772c3;
      }
    }
  }

  .user-actions {
    .user-info-trigger {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .user-name {
      margin-left: 12px;
      font-size: 16px;
      color: #1d2129;
    }

    .user-avatar {
      width: 32px;
      height: 32px;
      cursor: pointer;
      flex-shrink: 0;

      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }

    ::v-deep .ant-badge {
      display: flex;
      align-items: center;
    }

    ::v-deep .ant-badge-count {
      box-shadow: none;
    }
  }
}

.home-header {
  position: fixed;
  background: transparent;
  border-bottom: 0;
  box-shadow: 0;
}

.user-dropdown-menu {
  width: 168px;
  padding: 16px 0;
  text-align: center;

  .ant-dropdown-menu-item,
  .ant-menu-item {
    text-align: center;
    font-size: 17px;

    &:hover {
      background-color: transparent;
      color: #5772c3;
    }
  }
}

.work-center-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}
</style>
